import { Injectable } from '@angular/core';
import { ClientLocalization, CreateLocalizationListRequest } from '@ats/api/cm';
import { CmInterceptHeaders } from '@ats/cm/core';
import { gql, Mutation } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { ENTRY_EXISTS_GUID } from '../models/ignored-error-guids';

@Injectable({
	providedIn: 'root',
})
export class ClientLocalizationCreateGql extends Mutation<
	{ createClientLocalizationList: ClientLocalization[] },
	{ request: CreateLocalizationListRequest }
> {
	document = gql`
		mutation createClientLocalizationList($request: CreateLocalizationListRequest!) {
			createClientLocalizationList(request: $request) {
				name
				locType
				value
				englishValueResolved
				cultureInfoName
			}
		}
	`;

	create$(request: CreateLocalizationListRequest): Observable<string[]> {
		return this.mutate(
			{ request },
			{ context: { headers: CmInterceptHeaders.SuppressErrorById(ENTRY_EXISTS_GUID) } }
		).pipe(
			map(({ data }) => data?.createClientLocalizationList || []),
			map(locs => locs.map(loc => loc.name))
		);
	}
}
